import React from 'react';
import { View, Text, Linking } from 'react-native';

export default function MaintenancePage() {
  return (
    <View style={styles.root}>
      <View style={styles.inner}>
        <Text style={styles.heading}>The Configurator is temporarily offline</Text>
        <Text style={styles.body}>
          We're performing scheduled backend maintenance. Please check back soon.
        </Text>
        <Text style={styles.body}>
          If you have any questions, please email{' '}
          <Text
            style={styles.link}
            href="mailto:info@meljac-na.com"
          >
            info@meljac-na.com
          </Text>
          .
        </Text>
      </View>
    </View>
  );
}

const styles = {
  root: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  inner: {
    alignItems: 'center',
  },
  heading: {
    fontSize: 22,
    fontWeight: '500',
    color: '#222',
    textAlign: 'center',
    marginBottom: 16,
  },
  body: {
    fontSize: 15,
    lineHeight: 22,
    color: '#555',
    textAlign: 'center',
  },
  link: {
    color: '#0066cc',
    textDecorationLine: 'underline',
  },
};
